<template>
    
    <div class="not-found-view">
        <div class="container mx-auto px-4">
            <div class="py-12 text-center text-black">
                <img src="@/assets/img/hike-variant-2.png" alt="404" class="mx-auto max-w-32" />
                <h1 class="text-8xl mt-12 mb-2 font-bold">404</h1>
                <p class="text-6xl">Página no encontrada</p>
                <p class="text-lg">La página que buscas no existe o ha sido movida.</p>
                <router-link to="/" class="text-black underline">Volver al inicio</router-link>
            </div>
        </div>
    </div>
</template>